import { OwlRepository, RdfTriplet } from './OwlActions'

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialVOwlState = {
    load: false,
    description: [],
}
export const vowl = (state = { ...initialVOwlState} , action) => {
    switch (action.type) {
        case OwlRepository.EMPTY: 
            return{
                ...initialVOwlState,
                load: true
            };
        case OwlRepository.LOAD_STARTED: 
            return{
                ...state,
                load: true
            };
        case OwlRepository.LOAD_ERROR: 
            return {
                ...initialVOwlState,
                error: action.error
            };
        case OwlRepository.LOAD_LABELS:
            const n = [... state.description];
            let isExist = false;
            for (let i=0; i<n.length; i++) {
                if (isExist) break;
                const graph = n[i];
                if (graph.iri !== action.graph) continue;
                //Дальше смотрим только триплеты 
                if ((graph.subjects)&& Array.isArray(graph.subjects)){
                    for (let j=0; j<graph.subjects.length; j++) {
                        const subject = graph.subjects[j];
                        if (subject.iri == action.iri){
                            graph.subjects[j].values = action.values;
                            isExist = true;
                            break;
                        }
                    }
                    if (!isExist){
                        const s = {iri:action.iri, values:action.values};
                        graph.subjects.push(s);
                        isExist = true;
                        break;
                }
                }
            }
            if (!isExist){
                const g = {iri: action.graph};
                g.subjects=[{iri:action.iri, values:action.values}];
                n.push(g);
            }
            return {
                description: n,
            };

        case OwlRepository.LOAD_DESCRIPTIONS:
            const nd = [... state.description];
            return {
                description: nd,
            };

        default:
            return state;
    }
}

/** Описание выбранного триплета. Элемент используется для создания, модификации (включая перевод)
 * и удаления.
 */
const initialVSelectedState = {
    execution: false,               //Состояние выполнении операции    
    operation: "view",              //Вид операции
    subject:   undefined,           //Субъект
    predicat: undefined,            //Значение предиката
    value:  undefined,              //Текущее или новое значение (object)
    previous: undefined,            //Предыдущее значение (для операций редактирования, удаления)
}
export const vselected = (state = { ...initialVSelectedState} , action) => {
  switch (action.type) {
    case RdfTriplet.EMPTY: 
      return{
        ...initialVSelectedState,
      };
    case RdfTriplet.ERROR: 
      return{
        ...state,
        error:  action.error
    };
    case RdfTriplet.SELECTED: 
      return{
        ...state,
        operation: action.operation,
        subject:   action.subject,
        predicat: action.predicat,
        value:  action.value
    };
    default:
      return state;
  }
}

/** Описание таксономии на основе SKOS. Используется для отображения фильтров */
const initialVTaxonomy = {
    taxonomy: [],           //Список такосономий
}